import React from "react";
import classnames from "classnames";
import { formatDate } from "../../../../../helpers/date";

/**
 * @param {Date} weekStart
 * @param {Date} weekEnd
 * @param {Date} currentWeek
 * @param {function(Date): function} onClickWeekList
 */
const WeekListItem = ({ weekStart, weekEnd, currentWeek, onClickWeekList }) => {
  const current = new Date(currentWeek);

  return (
    <li
      className={classnames({
        selected: weekStart <= current && current <= weekEnd,
      })}
      onClick={onClickWeekList(weekStart)}
    >
      {formatDate(weekStart, { month: "short", day: "numeric" }) +
        " - " +
        formatDate(weekEnd, {
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
    </li>
  );
};

export default WeekListItem;
